(function (window, $) {
  $("html").removeClass("no-js");
  $("html").addClass("js");

  function ready() {
    $('.cube-needs-click').on('click',function(){
      if($(this).hasClass('cube-active')){
        //$('.cube-needs-click').removeClass('cube-active')
      }else{
        $('.cube-needs-click').removeClass('cube-active')
        $(this).addClass('cube-active')
      }
    });

    $('.has-subevents').on('click',function(){
      if(!$(this).hasClass('open')) {
        $('.event').removeClass('open');
        $('[data-event="'+$(this).attr('data-event')+'"]').addClass('open');
      }else{
        $('.event').removeClass('open');
      }
      return false;
    })
    pxSizeRatio();
    pxVideo();
    pxSetupAccordion();
    if(supportsWebp()){
      $('body').addClass('webp');
    }else{
      $('body').addClass('no-webp');
    }
    $('.offre-single .faits_saillants a.btn').click(function(){
      $('.wpcf7').css('display','block');
    })
    $(window).on('resize',function(){
      var topheight = 0;
      $('.carrieres-perspective .tranche_de_vie .slide .bg .flex').css('min-height','0');
      $('.carrieres-perspective .tranche_de_vie .slide .bg .flex').each(function(){
        if($(this).outerHeight()>topheight){
          topheight=$(this).outerHeight()
        }
      })
      $('.carrieres-perspective .tranche_de_vie .slide .bg .flex').css('min-height',topheight);
    }).trigger('resize');
    $(window).on('resize',function(){
      UnivEventsRedo();
      redoArrows()
      redoSameH();
    })
    //Recherche notre équipe.
    regenFormRecherche(false);
    $(".sidebar .option input").on("change", function () {
      $(".Listing").attr("currpage", 1);
      regenFormRecherche(true);
    });
    $(".SearchOpener").click(function () {
      $("body").toggleClass("searchOpen");
      if ($("body").hasClass("searchOpen")) {
        console.log("focus");
        $(".popupSearch input.autocomplete").focus();
      }
    });
    bootAutocomplete();
    $(".Pagination").on("click", ">div", function (e) {
      e.preventDefault();
      var topage = $(this).attr("goto");
      var currpage = $(".Listing").attr("currpage");
      if (!currpage) {
        currpage = 1;
      }
      var maxnumpage = $(".Listing").attr("maxnumpage");
      if (isNaN(topage)) {
        if (topage == "prev") {
          currpage--;
          if (currpage < 1) {
            currpage = 1;
          }
        }
        if (topage == "next") {
          currpage++;
          if (currpage > maxnumpage) {
            currpage = maxnumpage;
          }
        }
        $(".Listing").attr("currpage", currpage);
      } else {
        $(".Listing").attr("currpage", topage);
      }
      regenFormRecherche(true);
      return false;
    });
    /*$('.fancybox').fancybox({
			live: false
		});*/
    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    $(".COVIDBAR .close").click(function () {
      setCookie("covidbar", $(".COVIDBAR").attr("data-date"), 1);
      $(".COVIDBAR").css("display", "none");
    });
    $(".calltoaction .btn,.js-open-emailreminder").click(function () {
      $("body").addClass("reminderopen");
      return false;
    });
    $(".emailReminder").click(function (e) {
      if ($(e.target).hasClass("emailReminder") || $(e.target).hasClass("closer")) {
        $("body").removeClass("reminderopen");
      }
    });
    $(".ctavideo2018").click(function () {
      $("body").addClass("popupvideoopen");
      return false;
    });
    console.log("y");
    $(".popupVideos").click(function (e) {
      console.log($(e.target).attr("class"));
      if ($(e.target).hasClass("popupVideos")) {
        $("body").removeClass("popupvideoopen");
      }
    });
    $(".closeVideoPopup").click(function (e) {
      $("body").removeClass("popupvideoopen");
    });

    $(".toggle-menu-trigger").prop("checked", false);

    $(".cycle-slideshow").cycle();

    //Radio Buttons, Checkboxes
    $('form input[type="checkbox"]')
      .wrap('<span class="checkbox-wrapper"></span>')
      .addClass("input-hidden")
      .after('<span class="Checkbox"></span>');
    $('form input[type="radio"]')
      .wrap('<span class="radio-wrapper"></span>')
      .addClass("input-hidden")
      .after('<span class="Radio"></span>');

    $(".wpcf7-list-item").click(function () {
      if (
        $(this).find("input").is(":checked") &&
        $(this).find("input").attr("type") == "checkbox"
      ) {
        $(this).find("input").prop("checked", false);
      } else {
        $(this).find("input").prop("checked", true);
      }
    });

    $("form select:not(.plain-select)").dropkick({
      mobile: true,
    });
    $(":file").jfilestyle({
      buttonText:
        $("html").attr("lang").indexOf("fr") !== -1
          ? "Parcourir..."
          : "Browse...",
    });

    if ($("[data-waypoint]").length) {
      $("[data-waypoint]").waypoint();
    }

    //Scrollable table on small screens
    $(".Entry table").wrap('<div class="Table"></div>');

    function resize_cch_tax_alerts() {
      var height = 0;
      if ($("#cch_tax_alerts").length && $("#cch_tax_alerts>div").length) {
        $("#cch_tax_alerts>div").css("height", "");
        $("#cch_tax_alerts>div").each(function () {
          $(this).css("max-height", "none");
          $(this).css("left", "auto");
          if ($(this).outerHeight() > height) {
            height = $(this).outerHeight();
          }
          $(this).css("max-height", "");
          $(this).css("left", "");
        });
        $("#cch_tax_alerts>div").css("height", height);
        $("#cch_tax_alerts").css("height", height);
      } else if ($("#cch_tax_alerts").length) {
        setTimeout(resize_cch_tax_alerts, 150);
      }
    }

    $(window).on("resize", function () {
      var maxHeight = 0;
      $(".RH_info").css("height", "auto");
      $(".RH_info").each(function () {
        if ($(this).height() > maxHeight) {
          maxHeight = $(this).height();
        }
      });
      $(".RH_info").css("height", maxHeight + 37);
      $(".teammember").each(function () {
        $(this).css("height", $(this).width()*320/257);
      });

      resize_cch_tax_alerts();
    });
    $(window).trigger("resize");
    /*$(window).on('scroll',function(){
      $(window).trigger("resize");
    })*/

    //link anchor animated scroll
    $('*[href^="#"]').click(function (e) {
      e.preventDefault();
      var anchor = $(this).attr("href"),
        offset = $(anchor).offset(),
        position = 0;

      if (typeof offset === "object" && offset !== null) {
        position = offset.top;
      }
      $("html, body").animate(
        {
          scrollTop: position,
        },
        Math.abs($(window).scrollTop() - position) * 0.4
      );
    });

    //Office Block
    /*$(".cta-strip-office .IconLink").on("click", function (e) {
      e.preventDefault();
      $(this).parents(".cta-strip-office").addClass("cta-strip-office-active");
    });*/
    if ($(".cta-strip-office-slideshow").length) {
      $(".cta-strip-office-slideshow").cycle({
        fx: "scrollHorz",
        paused: true,
        log: false,
        speed: 550,
        slides: "> li",
        easing: "easeOutExpo",
        carouselVisible: 1,
        carouselFluid: true,
        prev: "~ .icon-anchor-circle-left",
        next: "~ .icon-anchor-circle-right",
        throttleSpeed: true,
        swipe: true,
        loader: true,
        //progressive: officeImages,
      });
    }

    $(".cta-strip-office-slideshow").on("cycle-before", function (
      event,
      optionHash,
      outgoingSlideEl,
      incomingSlideEl,
      forwardFlag
    ) {
      $(optionHash.slides).removeClass("cycle-slide-previous");
      $(outgoingSlideEl).addClass("cycle-slide-previous");
    });

    //Associates
    $(".associate-bio-wrapper").associatePager();
    $(".associate-bio-contact").on("click", "[data-phone]", function (e) {
      $(this).text($(this).data("phone"));
    });

    //Move page over banner as user scrolls
    $(window).off(".banner");
    if ($(".CONTENT_WRAPPER.content-wrapper-animated").length) {
      var canUpdate = true;
      function bannerEffect() {
        if (canUpdate) {
          var bannerHeight = $(".HEADER").outerHeight();
          if (bannerHeight) {
            var marginTop = Math.min($(window).scrollTop(), bannerHeight),
              opacity = (bannerHeight - marginTop) / (bannerHeight - 30);
            if (opacity < 1) {
              opacity *= 0.75;
            }
            $(".HEADER")
              .find(".LanguageLinks, .ToggleMenu, .Logo")
              .css("opacity", Math.min(opacity, 0.99));
            //$('.Banner .banner-filter').css('z-index', opacity === 0 ? 1 : 3);
            $(".CONTENT_WRAPPER").css("marginTop", marginTop * -1.1);
          } else {
            $(".CONTENT_WRAPPER").css("marginTop", 0);
          }
          canUpdate = false;
          setTimeout(function () {
            canUpdate = true;
          }, 1000 / 60); //sixty frame seconds
        }
      }
      $(window).on(
        "scroll.banner resize.banner touchmove.banner",
        bannerEffect
      );
    }
    if ($(".ASSOCIATES_CONTENT h1").length) {
      var canUpdateTitle = true;
      function titleEffect() {
        if (canUpdateTitle) {
          var bannerHeight = $(".ASSOCIATES_CONTENT h1").outerHeight() * 1.5;
          if (bannerHeight) {
            var maxTop = $(window).width() > 1024 ? 300 : 270,
              marginTop = Math.min($(window).scrollTop() * 1.1, maxTop),
              opacity = $(window).scrollTop() > 50 ? 0 : 1;
            $(".ASSOCIATES_CONTENT > .Container").css(
              "opacity",
              Math.min(opacity, 0.99)
            );
            //$('.Banner .banner-filter').css('z-index', opacity === 0 ? 1 : 3);
            //$('.HEADER').css('marginTop', marginTop);
            $(".ASSOCIATES").css("marginTop", marginTop * -1);
          } else {
            $(".ASSOCIATES").css("marginTop", 0);
          }
          canUpdateTitle = false;
          setTimeout(function () {
            canUpdateTitle = true;
            titleEffect();
          }, 1000 / 60); //sixty frame seconds
        }
      }
      $(window).on("scroll.banner resize.banner touchmove.banner", titleEffect);
    }

    //Tooltip
    $("[data-tooltip]").each(function () {
      $(this).data("tooltipTitle", $(this).attr("title"));
      $(this).data("tooltipEnabled", true);
      $(this).attr("data-tooltip-title", $(this).attr("title"));
      $(this).attr("title", "");
    });
    function placeTooltip(e) {
      var offset = 25;
      var scrollY = window.scrollY || window.pageYOffset;
      var scrollX = window.scrollX || window.pageXOffset;
      var tooltipTop = e.pageY + offset;
      var tooltipLeft = e.pageX + offset;
      var $tooltip = $("#tooltip");
      if ($tooltip.length) {
        tooltipTop =
          tooltipTop - scrollY + $tooltip[0].offsetHeight + 20 >=
          window.innerHeight
            ? tooltipTop - $tooltip[0].offsetHeight - 20
            : tooltipTop;
        tooltipLeft =
          tooltipLeft - scrollX + $tooltip[0].offsetWidth + 20 >=
          window.innerWidth
            ? tooltipLeft - $tooltip[0].offsetWidth - 20
            : tooltipLeft;
        $tooltip.css({
          top: tooltipTop + "px",
          left: tooltipLeft + "px",
        });
      }
    }
    $(".PAGE")
      .on("mouseover", "*[data-tooltip]", function (e) {
        $("#tooltip").remove();
        if ($(this).data("tooltipEnabled")) {
          $("body").append(
            '<div id="tooltip">' + $(this).data("tooltipTitle") + "</div>"
          );
          placeTooltip(e);
        }
      })
      .on("mouseout", "*[data-tooltip]", function () {
        $("#tooltip").remove();
      })
      .on("mousemove", "*[data-tooltip]", placeTooltip);

    $(".programmes .colProgr h3").click(function () {
      $(this).parent().toggleClass("active");
      return false;
    });
    $(".innerslide .more").click(function () {
      $(this).parent().toggleClass("active");
      if ($(this).parent().hasClass("active")) {
        $(".boxTestimonials .cycle-slideshow").cycle("pause");
      } else {
        $(".boxTestimonials .cycle-slideshow").cycle("resume");
      }
      $(".boxTestimonials .cycle-slideshow").cycle("update-view");
      return false;
    });

    if ($("#formInscription").length) {
      $("#formInscription .select2").select2();

      $("#formInscription").submit(function () {
        var data = {};
        var error = false;
        $("#formInscription .field").each(function () {
          var curVal = "";
          $(this).removeClass("error");
          if ($(this).find(">input").length) {
            //normals
            curVal = $(this).find("input").val();
            if (
              $(this).find("input").attr("name") == "allergy_specify" &&
              !curVal &&
              $('input[name="allergy"]:checked').val() == 0
            ) {
              curVal = "N/A";
            }
            console.log($('input[name="studyyr"]:checked').val());
            if (
              $(this).find("input").attr("name") == "studyyr_other" &&
              !curVal &&
              $('input[name="studyyr"]:checked').val() != 0
            ) {
              curVal = "N/A";
              console.log("x");
            }
            if (
              $(this).find("input").attr("type") == "email" &&
              !isEmail(curVal)
            ) {
              curVal = false;
            }
            data[$(this).find("input").attr("name")] = curVal;
          } else if ($(this).find(".choices input[type='checkbox']").length) {
            //checkboxes
            var dataname=$(this).find('.choices').attr('data-name');
            console.log($(this));
            $(this).find(".choices input[type='checkbox']:checked").each(function(){
              curVal += $(this).val() + ',';
            })
            //curVal = $(this).find("input:checked").val();
            data[dataname] = curVal;
            console.log(dataname);
            console.log(curVal);
          } else if ($(this).find(".choices input").length) {
            //radios
            curVal = $(this).find("input:checked").val();
            data[$(this).find("input:checked").attr("name")] = curVal;
          } else if ($(this).find("select").length) {
            //selects
            curVal = $(this).find("select").val();
            data[$(this).find("select").attr("name")] = curVal;
          } else if ($(this).find("textarea").length) {
            //textarea
            curVal = $(this).find("textarea").val();
            if (!curVal) {
              curVal = "N/A";
            }
            data[$(this).find("textarea").attr("name")] = curVal;
          } else {
            //catchall
            curVal = $(this).find("select,input").val();
            data[$(this).find("select,input").attr("name")] = curVal;
          }
          if (!curVal || curVal == "undefined") {
            $(this).addClass("error");
            error = true;
          }
        });
        var disponibility = $("select[name='disponibility']").val();
        if (disponibility) {
          disponibility = disponibility.join();
          data["disponibility"] = disponibility;
        }
        console.log(data);
        if (!error) {
          $('#formInscription input[type="submit"]').prop("disabled", true);
          jQuery.post(
            ajaxurl,
            {
              action: "inscription_stage",
              data: data,
            },
            function (response) {
              console.log(response);
              $('#formInscription input[type="submit"]').prop(
                "disabled",
                false
              );
              if (
                response == "firstin" ||
                response == "waitlist" ||
                response == "full" ||
                response == "existingemail"
              ) {
                $(".popup .content,.popup .header").css("display", "none");
                $(".popup .content." + response).css("display", "block");
                $(".popup .header." + response).css("display", "flex");
                $("body").addClass("popupActive");
              }
              if (
                response == "firstin" ||
                response == "waitlist" ||
                response == "full"
              ) {
                $("body").removeClass("competitionopen");
              }
            }
          );
        } else {
          $(document).scrollTop($("#formInscriptionTitle").offset().top);
          //$('#formInscription')
        }
        return false;
      });

      $('[name="university"]').change(function () {
        var univ = $(this).val();
        jQuery.post(
          ajaxurl,
          {
            action: "checkFillUniv",
            data: univ,
          },
          function (response) {
            console.log(response);
            if (
              response == "firstin" ||
              /*response == "waitlist" ||*/ response == "full" ||
              response == "existingemail"
            ) {
              $(".popup .content,.popup .header").css("display", "none");
              $(".popup .content." + response).css("display", "block");
              $(".popup .header." + response).css("display", "flex");
              $("body").addClass("popupActive");
            }
            if (
              response == "firstin" ||
              /*response == "waitlist" ||*/ response == "full"
            ) {
              $("body").removeClass("competitionopen");
            }
          }
        );
      });

      $(".btnClose,.closeX").click(function () {
        $("body").removeClass("popupActive");
      });
    }
    $(".recrutementpsb .headerText .btn,.header-menu .btn,.competitionopener").on(
      "click",
      function () {
        $("body").addClass("competitionopen");
      }
    );
    $("#formInscription .cancel").click(function () {
      $("body").removeClass("competitionopen");
    });
    if ($(".TypeQuiz").length) {
      function resizeQuizContent() {
        var maxHeight = 0;
        $(".mfp-content").addClass("mfp-calculating-height");
        $(".type-quiz-question").each(function () {
          if ($(this).outerHeight() > maxHeight) {
            maxHeight = $(this).outerHeight();
          }
        });
        $(".mfp-content").css("height", maxHeight);
        $(".mfp-content").removeClass("mfp-calculating-height");
      }
      $(".typepsb .headerText .btn").magnificPopup({
        callbacks: {
          open: function () {
            var $quiz = $(this.content);
            //Reset quiz
            resizeQuizContent();
            $quiz.removeClass("type-quiz-show-profile");
            //$quiz.addClass('type-quiz-show-profile');
            $quiz.find("input[type=radio]").prop("checked", false);
            $quiz.find("button[type=button].BtnRainbow").prop("disabled", true);
            $quiz
              .find(".type-quiz-question")
              .removeClass("type-quiz-question-hide")
              .css("margin-left", 0);
            $quiz
              .find(".a2a_button_instagram")
              .attr("href", "https://www.instagram.com/psbboisjoli");
          },
        },
        items: {
          src: $(".TypeQuiz"),
          type: "inline",
        },
      });
      //$('.headerText .btn').trigger('click');
      $(".TypeQuiz input[type=radio]").on("change", function () {
        $(this)
          .parents(".type-quiz-question")
          .find("button")
          .prop("disabled", false);
      });
      $(".type-quiz-next").on("click", function () {
        var $parent = $(this).parent(".type-quiz-question"),
          $container = $(this).parents(".type-quiz-questions");
        if ($parent.find(":checked").length) {
          $parent.addClass("type-quiz-question-hide");
          $remaining = $container.find("> :not(.type-quiz-question-hide)");
          $remaining.css(
            "margin-left",
            ($container.find("> .type-quiz-question-hide").length * -4.528) /
              2 +
              "%"
          );

          if (!$remaining.length) {
            var $quiz = $(this).parents(".TypeQuiz"),
              $answers = $quiz.find(":checked"),
              points = 0,
              $profiles = $quiz.find(".type-quiz-profile");
            $answers.each(function () {
              points += parseInt($(this).val());
            });
            $profiles.hide().each(function () {
              if (
                points >= parseInt($(this).data("minPoints")) &&
                points <= parseInt($(this).data("maxPoints"))
              ) {
                $(this).show();
                var profile_url =
                  window.location.pathname +
                  "?profile=" +
                  $(this).data("profile");
                window.history.pushState(
                  $(this).find("p").text(),
                  $(this).find("h3").text(),
                  profile_url
                );
              }
            });
            $quiz.addClass("type-quiz-show-profile");
          }
        }
      });
      $(window).on("resize", resizeQuizContent);
    }
    $(".secondary-nav-collapse").each(function () {
      var $this = $(this),
        $handles = $(".secondary-nav-toggle", this);
      $handles.on("click", function () {
        $(this).toggleClass("secondary-nav-active");
      });
    });

    $(".fiscalistes-content-box").each(function () {
      var $wrapper = $(this),
        $contents = $(".fiscalistes-content", this);
      $wrapper.addClass("fiscalistes-content-box-active");
      function resizeContentBox() {
        var maxHeight = 0;
        $contents.each(function () {
          if ($(this).height() > maxHeight) maxHeight = $(this).height();
        });
        $wrapper.height(maxHeight);
      }
      resizeContentBox();
      $(window).on("resize", resizeContentBox);
      $contents.eq(0).addClass("fiscalistes-content-active");

      //Build paginator
      var $nav = $(
          '<nav class="fiscalistes-content-box-nav fiscalistes-content-box-nav-start"></nav>'
        ),
        $pages = $(
          '<span class="fiscalistes-content-box-pages">1 / ' +
            $contents.length +
            "</span>"
        );
      $nav.append('<button class="icon-arrow-left"></button>');
      $nav.append($pages);
      $nav.append('<button class="icon-arrow-right"></button>');
      $wrapper.append($nav);
      $('[class*="icon-arrow"]', $nav).on("click", function () {
        var $active = $contents.filter(".fiscalistes-content-active"),
          activeIndex = $active.index();
        $nav.removeClass(
          "fiscalistes-content-box-nav-start fiscalistes-content-box-nav-end"
        );
        if ($(this).hasClass("icon-arrow-left")) activeIndex--;
        if ($(this).hasClass("icon-arrow-right")) activeIndex++;
        activeIndex = Math.max(activeIndex, 0);
        activeIndex = Math.min(activeIndex, $contents.length - 1);
        if (activeIndex == 0)
          $nav.addClass("fiscalistes-content-box-nav-start");
        if (activeIndex == $contents.length - 1)
          $nav.addClass("fiscalistes-content-box-nav-end");
        $active.removeClass("fiscalistes-content-active");
        $contents.eq(activeIndex).addClass("fiscalistes-content-active");
        $pages.text(activeIndex + 1 + " / " + $contents.length);
      });
    });

    $(".fiscalistes-team").each(function () {
      $(this).addClass("fiscalistes-team-active");
      var $items = $(".fiscalistes-team-item", this),
        $nav = $('<nav class="fiscalistes-team-nav"></nav>'),
        $pages = $("<ol></ol>");
      $items.eq(0).addClass("fiscalistes-team-active");
      $nav.append('<button class="icon-anchor-circle-left"></button>');
      $nav.append('<button class="icon-anchor-circle-right"></button>');
      $pages.append("<li></li>".repeat($items.length));
      $pages.children().eq(0).addClass("fiscalistes-team-active");
      $nav.append($pages);
      $(this).append($nav);
      $('[class*="icon-anchor"]', $nav).on("click", function () {
        var $active = $items.filter(".fiscalistes-team-active"),
          activeIndex = $active.index();

        if ($(this).hasClass("icon-anchor-circle-left")) activeIndex--;
        if ($(this).hasClass("icon-anchor-circle-right")) activeIndex++;
        activeIndex =
          activeIndex < 0
            ? $items.length - 1
            : activeIndex > $items.length - 1
            ? 0
            : activeIndex;
        $active.removeClass("fiscalistes-team-active");
        $items.eq(activeIndex).addClass("fiscalistes-team-active");
        $pages
          .children()
          .removeClass("fiscalistes-team-active")
          .eq(activeIndex)
          .addClass("fiscalistes-team-active");
      });
    });

    $(".Trainees").each(function () {
      var $this = $(this),
        $wrapper = $this.find(".trainees-items"),
        $items = $this.find("li"),
        $pages = $('<ol class="trainees-pages"></ol>');

      var scrollThreshold = 40;
      $wrapper.css("overflow", "hidden");
      $this.append('<button class="icon-anchor-circle-left"></button>');
      $this.append('<button class="icon-anchor-circle-right"></button>');
      $pages.append("<li></li>".repeat($items.length));
      $pages.children().eq(0).addClass("trainees-active");
      $this.append($pages);
      $items.eq(0).addClass("trainees-active");
      function adjustScrollPosition(e) {
        var $active = $items.filter(".trainees-active");
        var $activeText = $(".trainees-active .trainees-text");
        /*var $activeTextLeft = $activeText.css('left');
			$activeTextLeft = parseInt($activeTextLeft.replace('px',''));*/
        var paddingLeft = parseInt($active.css("padding-left"));
        var marginRight = Math.abs(parseInt($active.css("margin-right")));
        var marginLeft = parseInt($active.css("margin-left"));
        var appliedMargin = marginRight < 0 ? marginRight : marginLeft;
        var position = $active.index() * ($active.outerWidth() - marginRight);
        if (
          typeof e !== "undefined" &&
          ["load", "resize"].indexOf(e.type) >= 0
        ) {
          $wrapper.scrollLeft(position);
        } else {
          $wrapper.animate({ scrollLeft: position }, { duration: 300 });
        }
      }
      function adjustActiveItem(newIndex) {
        var $active = $items.filter(".trainees-active");
        newIndex =
          newIndex < 0
            ? $items.length - 1
            : newIndex > $items.length - 1
            ? 0
            : newIndex;
        $active.removeClass("trainees-active");
        $items.eq(newIndex).addClass("trainees-active");
        adjustScrollPosition();
        $pages
          .children()
          .removeClass("trainees-active")
          .eq(newIndex)
          .addClass("trainees-active");
      }
      $('[class*="icon-anchor"]', $this).on("click", function () {
        var $active = $items.filter(".trainees-active"),
          activeIndex = $active.index();
        if ($(this).hasClass("icon-anchor-circle-left")) activeIndex--;
        if ($(this).hasClass("icon-anchor-circle-right")) activeIndex++;
        adjustActiveItem(activeIndex);
      });
      $this.on("touchstart", function (e) {
        var touch =
          e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
        var elm = $(this).offset();
        var x = touch.pageX - elm.left;
        var y = touch.pageY - elm.top;
        $this.data("initial-position", [x, y]);
        $wrapper.data("initial-scroll", $wrapper.scrollLeft());
      });
      $this.on("touchend", function (e) {
        var touch =
          e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
        var elm = $(this).offset();
        var x = touch.pageX - elm.left;
        var y = touch.pageY - elm.top;
        var initialPosition = $this.data("initial-position");
        var diffScroll =
          $wrapper.scrollLeft() - $wrapper.data("initial-scroll");
        if (
          Math.abs(initialPosition[1] - y) < scrollThreshold &&
          Math.abs(diffScroll) > scrollThreshold
        ) {
          var current = $items.filter(".trainees-active").index();
          adjustActiveItem(diffScroll > 0 ? current + 1 : current - 1);
        } else {
          adjustScrollPosition();
        }
      });
      $this.on("touchmove", function (e) {
        var touch =
          e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
        var elm = $(this).offset();
        var x = touch.pageX - elm.left;
        var y = touch.pageY - elm.top;
        var initialPosition = $this.data("initial-position");
        if (Math.abs(initialPosition[1] - y) < scrollThreshold) {
          $wrapper.scrollLeft(
            $wrapper.data("initial-scroll") + (initialPosition[0] - x)
          );
        }
      });
      $(window).on("load", adjustScrollPosition);
      $(window).on("resize", adjustScrollPosition);
    });
  }
  $(function () {
    /*var smoothState = $('#BODY').smoothState({
			anchors: 'a:not(.Associate .post-thumbnail, .associate-content .BackLink, .associate-bio-contact .Button)',
			forms:'form:not(.wpcf7-form,.PixelmailForm)',
			hrefRegex: /^(?!.*(wp-content)).*$/,
			alterRequest: function(request) {
				request.xhr = function () {
					var xhr = new window.XMLHttpRequest();
					//Download progress
					var loadedPercent = 0;
					xhr.addEventListener("progress", function (e) {
						if (e.lengthComputable) {
							var percentComplete = e.loaded / e.total*30;
							$('.Loader .loader-logo').width(percentComplete + "%");
						} else {
							loadedPercent += 5;
							$('.Loader .loader-logo').width(Math.min(loadedPercent, 30) + "%");
						}
					}, false);
					xhr.addEventListener("load", function (e) {
						var regex = /<html.*?lang="([a-zA-Z\-]+)"/g;
						$('html').attr('lang', regex.exec(this.response)[1]);
					});
					return xhr;
				};

				return request;
			},
			onStart: {
				duration: 600, // Duration of our animation
				render: function ($container) {
					$('.cycle-slideshow').cycle('destroy');
					// Add your CSS animation reversing class
					$('.Loader').addClass('loader-active');
					// Restart your animation
					smoothState.restartCSSAnimations();
				}
			},
			onProgress: {
				duration: 300,
				render: function() {}
			},
			onAfter: function() {
				$('#BODY').addClass('loaded');
				$('.Loader').removeClass('loader-fade');
				$('.Loader .loader-logo').width(0);
			},
			onReady: {
				duration: 600,
				render: function ($container, $newContent) {
					$(window).scrollTop(0);
					$('#BODY').removeClass('loaded');
					// Inject the new content
					$container.html($newContent);

					$('body').waitForImages(function() {
						// Remove your CSS animation reversing class
						setTimeout(function() {
							$('.Loader').removeClass('loader-active');
							window.a2a && window.a2a.init_all("page");
							ready();
							$('.ASSOCIATES').associates();
							$('.associate-bio-wrapper').associatePager('update-pager');
							$('.cycle-slideshow').cycle()
							//$('.fancybox').fancybox({
							//	live: false
							//});
						}, 350);
					}, function(loaded, count, failed) {
						var percent = (loaded+1)/count*70;
						$('.Loader .loader-logo').width(percent+30+'%');
					});

				}
			}
		}).data('smoothState');*/

    $(".Loader .loader-logo").width("30%");
    $("body").waitForImages(
      function () {},
      function (loaded, count, failed) {
        var percent = ((loaded + 1) / count) * 70;
        $(".Loader .loader-logo").width(percent + 30 + "%");
      }
    );
    ready();
    $("#BODY").on("change", "#main-menu", function () {
      if ($(this).is(":checked")) {
        $(".Loader").addClass("loader-fade");
      } else {
        $(".Loader").removeClass("loader-fade");
      }
    });
    $("#BODY").addClass("ready js");
    $(window).on("load", function () {
      setTimeout(function () {
        $(".Loader").removeClass("loader-active");
        setTimeout(function () {
          $(".Loader .loader-logo").width(0);
        }, 600);
      }, 350);
      $("#BODY").addClass("loaded");
      $(".ASSOCIATES").associates();
      $(".associate-bio-wrapper").associatePager("update-pager");
    });

    //popups ambassadeurs
    console.log("b");
    $(".popupAmbassadeurs").each(function () {
      if ($(this).hasClass("active")) {
        $("#BODY").addClass("popupAmbassadeurActive");
      }
    });
    $("[data-open-amb]").click(function (event) {
      //event.preventDefault();
      $(window).trigger("resize");
      var slidenb = $(this).attr("data-open-amb");
      $("#BODY").addClass("popupAmbassadeurActive");
      $(".popupAmbassadeurs").removeClass("exiting");
      $(".popupAmbassadeurs.active").addClass("exiting");
      $(".cycle-slideshow").cycle("goto", 0);
      window.setTimeout(function () {
        $(".popupAmbassadeurs").removeClass("active");
        $(".popupAmbassadeurs").removeClass("exiting");
        $('.popupAmbassadeurs[data-popup-nb="' + slidenb + '"]').addClass(
          "active"
        );
        $("body").css("overflow", "hidden");
      }, 300);
      return false;
    });

    $(".closePopups,.popupsAmbassadeurs .closer").on(
      "click",
      function (e) {
        //console.log($(e.target).attr('class'));
        $("#BODY").removeClass("popupAmbassadeurActive");
        $(".popupAmbassadeurs.active").addClass("exiting");
        $(".popupAmbassadeurs").removeClass("active");
        $("body").attr("style", "");
      }
    );

    $(window)
      .resize(function () {
        var h = 0;
        $(".popupsAmbassadeurs .section1").css("min-height", 0);
        $(".popupsAmbassadeurs .section1").each(function () {
          if ($(this).outerHeight() > h) {
            h = $(this).outerHeight();
          }
        });
        $(".popupsAmbassadeurs .section1").css("min-height", h);
      })
      .trigger("resize");

    $(".popupAmbassadeurs").on("scroll", function () {
      console.log($(this).scrollTop());
      var scroll = $(this).scrollTop() - 100;
      if (scroll < 0) {
        scroll = 0;
      }
      $(this).find(".image").css("top", scroll);
      $(this)
        .find(".quote")
        .css("transform", "translateY(" + $(this).scrollTop() + "px)");
    });

    /*var tooltip = document.querySelectorAll('.followtooltip');

		document.addEventListener('mousemove', fn, false);

		console.log('y');
		function fn(e) {
			console.log('x');
			for (var i=tooltip.length; i--;) {
				tooltip[i].style.left = e.pageX + 'px';
				tooltip[i].style.top = e.pageY + 'px';
			}
		}*/
    //$(window).on('mousemove',function(){
    document.addEventListener("mousemove", fn, false);
    function fn(e) {
      $(".followtooltip").each(function (event) {
        var mousepos = $(this).parent().offset();
        var x = e.pageX - mousepos.left;
        var y = e.pageY - mousepos.top;
        x++;
        y++;
        $(this).css("left", x + "px");
        $(this).css("top", y + "px");
        window.setTimeout(function () {
          x--;
          y--;
          $(this).css("left", x + "px");
          $(this).css("top", y + "px");
        }, 1);
      });
    }
  });
})(window, jQuery);

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function trimByWord(sentence, length) {
  var result = sentence;
  var resultArray = result.split(" ");
  if (resultArray.length > length) {
    resultArray = resultArray.slice(0, length);
    result = resultArray.join(" ") + "&hellip;";
  }
  return result.replace(/<\/?[^>]+(>|$)/g, "");
}

function cacheElement(htmldump, lang) {
  console.log("cachestart");
  jQuery.post(
    ajaxurl,
    {
      action: "pix_cachelement",
      htmldump: htmldump,
      lang: lang,
    },
    function (response) {
      console.log("cached " + response);
    }
  );
}

function regenFormRecherche(scrollto) {
  console.log("regen");
  if (scrollto) {
    console.log("scrollto");
    //$('.Listing').scrollIntoView(true);
    var offset = $(".Listing").offset();
    $("html, body").animate(
      {
        scrollTop: offset.top - 50,
      },
      300
    );
  } else {
    console.log("dont scrollto");
  }
  var serviceson = false;
  var titleson = false;
  $(".Assoc_Card").removeClass("titleOK");
  $(".Assoc_Card").removeClass("serviceOK");
  $('.categ .option input[type="checkbox"]:checked').each(function () {
    var val = $(this).attr("name");
    val = val.split("-");
    if (val[0] == "titre") {
      titleson = true;
      $(".Assoc_Card").each(function () {
        var titre = $(this).attr("pix-titre");
        titre = titre.split(",");
        if (titre.includes(val[1])) {
          $(this).addClass("titleOK");
        }
      });
    }
    //console.log(val[0]);
    if (val[0] == "service") {
      serviceson = true;
      $(".Assoc_Card").each(function () {
        var titre = $(this).attr("pix-specs");
        titre = titre.split(",");
        //console.log(val[1]);
        if (titre.includes(val[1])) {
          $(this).addClass("serviceOK");
        }
      });
    }
  });
  if (!serviceson) {
    $(".Assoc_Card").addClass("serviceOK");
  }
  if (!titleson) {
    $(".Assoc_Card").addClass("titleOK");
  }
  var i = 0;
  var currpage = $(".Listing").attr("currpage");
  if (!currpage) {
    currpage = 1;
  }
  $(".Assoc_Card").each(function () {
    if ($(this).hasClass("serviceOK") && $(this).hasClass("titleOK")) {
      $(this).addClass("showcard");
      i++;
      $(this).attr("onpage", Math.ceil(i / 9));
      if (currpage == Math.ceil(i / 9)) {
        $(this).addClass("oncurpage");
      } else {
        $(this).removeClass("oncurpage");
      }
    } else {
      $(this).removeClass("showcard");
      $(this).removeClass("oncurpage");
    }
  });
  var maxnumpage = Math.ceil($(".Assoc_Card.showcard").length / 9);
  $(".Listing").attr("maxnumpage", maxnumpage);
  //Recreate pagination
  var html = "";
  if (maxnumpage >= 2) {
    html += '<div goto="prev"></div>';
  }
  for (var i = 1; i <= maxnumpage; i++) {
    var cssclass = "";
    //console.log(currpage)
    if (i == currpage) {
      cssclass = "active";
    }
    html += '<div goto="' + i + '" class="' + cssclass + '">' + i + "</div>";
  }
  if (maxnumpage >= 2) {
    html += '<div goto="next"></div>';
  }
  $(".Pagination").html(html);
  redoArrows()
}

function redoArrows(){
  $(".Assoc_Card").each(function () {
    $(this).find('.CTA span').css('margin-right',0);
    var margin = $(this).width() - $(this).find('.CTA span').outerWidth() - $(this).find('.CTA img').outerWidth() - 8;
    $(this).find('.CTA span').css('margin-right',margin+'px');
  })
}

function bootAutocomplete() {
  var choices = [];
  var choiceWURL = [];
  $("a.Assoc_Card").each(function () {
    choices.push([$(this).find("h3").html(), $(this).attr("href")]);
  });
  //console.log(choices)
  $(".FormAutocomplete input[autocomplete]").autoComplete({
    minChars: 1,
    source: function (term, suggest) {
      term = term.toLowerCase();
      //var choices = [['Australia', 'au'], ['Austria', 'at'], ['Brasil', 'br'], ...];
      var suggestions = [];
      for (i = 0; i < choices.length; i++) {
        //console.log(term + ' : ' + choices[i][0].toLowerCase());
        if (choices[i][0].toLowerCase().indexOf(term) != -1)
          suggestions.push(choices[i]);
      }
      suggest(suggestions);
    },
    renderItem: function (item, search) {
      search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      var re = new RegExp("(" + search.split(" ").join("|") + ")", "gi");
      return (
        '<div class="autocomplete-suggestion" data-url="' +
        item[1] +
        '" data-val="' +
        search +
        '"><a href="' +
        item[1] +
        '">' +
        item[0].replace(re, "<b>$1</b>") +
        "</a></div>"
      );
    },
    onSelect: function (e, term, item) {
      //alert('Item "'+item.data('url')+' ('+item.data('lang')+')" selected by '+(e.type == 'keydown' ? 'pressing enter' : 'mouse click')+'.');
      //console.log(term);
      window.location.href = item.data("url");
    },
  });
  $(".autocomplete-suggestions").css("display", "none");

  //Search
  var searchRequest,
    urls = [],
    matches = [];
  $('.popupSearch input[type="text"]').autoComplete({
    minChars: 1,
    onSelect: function (e, term, item) {
      /*matches = matches.map(function(v) {
				return v.toLowerCase();
			});*/
      /*console.log(matches);
			console.log(term);
			console.log(item);
			console.log(matches.indexOf(term));
			if(matches.indexOf(term) != -1){
				window.location = urls[matches.indexOf(term)];
			}*/
      window.location.href = item.data("url");
    },
    renderItem: function (item, search) {
      var cururl = urls[matches.indexOf(item)];
      search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      var re = new RegExp("(" + search.split(" ").join("|") + ")", "gi");
      return (
        '<div class="autocomplete-suggestion ofpopup" data-url="' +
        cururl +
        '" data-val="' +
        search +
        '"><a href="' +
        item[1] +
        '">' +
        item.replace(re, "<b>$1</b>") +
        "</a></div>"
      );
    },
    source: function (term, suggest) {
      console.log(autocompleteurl);
      try {
        searchRequest.abort();
      } catch (e) {}
      searchRequest = $.get(autocompleteurl, {}, function (res) {
        var words = term.split(" "),
          words_exp = words.join("|");
        var len = res.length,
          perfect_match_regex = new RegExp(term, "gi"),
          words_regex = new RegExp(words_exp, "gi");
        (urls = []), (matches = []);
        var low_priority_results = [],
          high_priority_results = [];
        for (var i = 0; i < len; i++) {
          var result = res[i];
          if (result.title.match(perfect_match_regex)) {
            high_priority_results.unshift(result);
            continue;
          }
          var words_matches = result.title.match(words_regex),
            unique_matches = [];
          if (words_matches) {
            for (var j = 0; j < words_matches.length; j++) {
              var word = words_matches[j].toLowerCase();
              if (unique_matches.indexOf(word) < 0) {
                unique_matches.push(word);
              }
            }
            if (unique_matches.length > 1) {
              matches.unshift(result.title);
              urls.unshift(result.url);
            } else if (words_matches.length > 1) {
              matches.push(result.title);
              urls.push(result.url);
            } else {
              low_priority_results.push(result);
            }
          }
        }
        for (var i = 0; i < low_priority_results.length; i++) {
          matches.push(low_priority_results[i].title);
          urls.push(low_priority_results[i].url);
        }
        for (var i = 0; i < high_priority_results.length; i++) {
          matches.unshift(high_priority_results[i].title);
          urls.unshift(high_priority_results[i].url);
        }
        suggest(matches);
      });
    },
  });
}

function pxSetupAccordion(){
  $(window).on('resize',function(){
    $('.accordion .text').each(function(){
      $(this).css('max-height',$(this).find('div').outerHeight());
    })
  }).trigger('resize')
  $('.accordion a').click(function(){
    var reopen = true;
    if($(this).parent().hasClass('active')){
      reopen = false;
    }
    $('.accordion').removeClass('active');
    if(reopen){
      $(this).parent().addClass('active');
      //var thisEl = $(this);
      /*window.setTimeout(function(){
        var offset = thisEl.offset();
        window.scrollTo({left:0,top:offset.top-100,behavior:'smooth'});
      },300)*/
    }
    return false;
  })
}

function pxSizeRatio(){
  $(window).on('scroll resize',function(){
    $('[px-size-ratio]').each(function(){
      var oldW = $(this).attr('oldW');
      if(oldW != $(this).outerWidth()){
        var attributes = $(this).attr("px-size-ratio");
        attributes = attributes.split(':');
        if($(this)[0].hasAttribute('px-size-important')){
            $(this).css('height',$(this).outerWidth()*attributes[1]/attributes[0]+'px !important');
        }else{
            $(this).css('height',$(this).outerWidth()*attributes[1]/attributes[0]);
        }
        $(this).attr('oldW',$(this).outerWidth())
      }
    })
  })
}

function pxVideo(){
  //Vidéos
  $('.px-video').each(function(){
    var video = $(this).attr("data-loaded-video");
    if(!$(this).find('.px-malleable-image img').attr('src')){
        if(video.includes('youtube') || video.includes('yt')){
            console.log('youtube no thumb')
            var videoId = yt_get_id(video)
            $(this).find('.px-malleable-image img').attr('src','//img.youtube.com/vi/'+videoId+'/maxresdefault.jpg')
        }
    }
  })
  $('.px-video').click(function(){
      var video = $(this).attr("data-loaded-video");
      if(video){
          console.log(video);
          if(video.includes('youtube') || video.includes('yt')){
              var videoId = yt_get_id(video)
              $(this).addClass('is-video-loaded');
              $(this).html('<iframe src="//www.youtube.com/embed/' + videoId + '?autoplay=1" px-size-ratio="16:9" allow="autoplay; fullscreen" frameborder="0" allowfullscreen></iframe>');
          }else if(video.includes('vimeo')){
              var videoId = vimeo_get_id(video)
              $(this).addClass('is-video-loaded');
              $(this).html('<iframe src="//player.vimeo.com/video/'+videoId+'?api=1&player_id=1&api=1&player_id=2&autoplay=1" px-size-ratio="16:9" allow="autoplay; fullscreen" frameborder="0" allowfullscreen></iframe>');
          }
          $(window).trigger('resize');
          return false;
      }
  })
}

function yt_get_id(url){
  var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  var match = url.match(regExp);

  if (match && match[2].length == 11) {
      return match[2];
  } else {
      return 'error';
  }
}

function vimeo_get_id(url){
  //var url = "http://www.vimeo.com/7058755";
  var regExp = /https?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;

  var match = url.match(regExp);

  if (match){
      return match[3];
  }
  else{
      alert("not a vimeo url");
  }
}

function supportsWebp() {
  var elem = document.createElement('canvas');

  if (!!(elem.getContext && elem.getContext('2d')))
  {
    // was able or not to get WebP representation
    return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
  }
  else
  {
    // very old browser like IE 8, canvas not supported
    return false;
 }
}

function UnivEventsRedo(){
  var pageH = $('#BODY.recrutementpsb .PAGECarrieres').outerHeight();
  if(pageH){
    $('html,body').css('min-height',pageH)
  }
  var height=0;
  $('.recrutementpsb .events .event>div').css('height','auto');
  $('.recrutementpsb .events .event').each(function(){
    var h1 = $(this).find('.date').outerHeight() + $(this).find('.normal').outerHeight();
    var h2 = $(this).find('.hover>div').outerHeight() + $(this).find('.normal').outerHeight();
    $(this).find('>div').attr('h',$(this).find('>div').outerHeight())
    $(this).find('>div').attr('h-n',$(this).find('.normal').outerHeight())
    $(this).find('>div').attr('h-d',$(this).find('.date').outerHeight())
    $(this).find('>div').attr('h-h',$(this).find('.hover>div').outerHeight())
    console.log($(this).find('>div').outerWidth());
    if($(this).find('>div').outerWidth() > height && !$(this).hasClass('is-subevent')){
      height = $(this).find('>div').outerWidth();
      if(h1 > height){
        height = h1;
      }
      if(h2 > height){
        height = h2;
      }
    }else if($(this).hasClass('is-subevent')){
      var h = h1 + $(this).find('.btn').outerHeight() + 24;
      if(h > height){
        height = h;
      }
    }
  })
  $('.recrutementpsb .events .event>div').css('height',height);
  /*$('.recrutementpsb .events .event').each(function(){
    var height = $(this).find('>div').height() - $(this).find('.date').height();
    $(this).find('.normal,.hover').css('height',height);
  })*/
}

function redoSameH(){
  var categs = [];
  $('[px-same-height]').each(function(){
    if(!categs.includes($(this).attr('px-same-height'))){
      categs.push($(this).attr('px-same-height'));
    }
  });
  categs.forEach(function(element){
    var thish = 0;
    $('[px-same-height=\"'+element+'\"]').css('height','auto');
    $('[px-same-height=\"'+element+'\"]').each(function(){
      if($(this).outerHeight() > thish){
        thish = $(this).outerHeight();
      }
    })
    $('[px-same-height=\"'+element+'\"]').css('height',thish+'px');
  })
}